import { Component, OnInit, ViewChild, Injector, signal, model, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { LoaderService } from '../services/loader.service';
import { LineStateActionService } from '../statemanagement/line-state-action.service';
import { VerifyIdentityService } from '../services/verify-identity.service';
import { VerifyIdentity } from '../models/verifyIdentity.model';
import { ResponseStateVerifyIdentity } from '../models/verify.model';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponents } from '../../../base.component';
import { ReferenceService } from 'src/app/services/reference.service';
import { GetMaskingService } from 'src/app/adapters/getMasking.service';
@Component({
  selector: 'app-verify-identity-form',
  templateUrl: './verify-identity-form.component.html',
  styleUrls: ['./verify-identity-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone:false
})
export class VerifyIdentityFormComponent extends BaseComponents implements OnInit {

  constructor(
    protected injectorObj: Injector,
    private router: Router,
    private route: ActivatedRoute,
    private loaderService: LoaderService,
    private lineStateAction: LineStateActionService,
    private verifyIdentityService: VerifyIdentityService,
    private referenceService:ReferenceService,
    private getMaskingService : GetMaskingService
  ) { 
    super(injectorObj);
  }

  model = model<any>({
    form: {
      idcard: { value: '', text: '' }
    }
  })
  bg_image = "/assets/images/bg-form/#brand#-bg-verify-form-s.png";
  // remarkText = "";
  verifyIdentityInvalid = signal<boolean>(false);
  navigate = "";
  queryParams = {}
  log_session_text: string = "form-readonly";
  referenceUUID: string | null = null;

  ngOnInit() {
    const funcName = 'ngOnInit';
    this.referenceUUID = this.referenceService.getReferenceUUID();
    this.log_session_text = `verify-identity-form referenceUUID:[${this.referenceUUID}]`;
    this.logger.info(`${this.log_session_text} ${funcName} start`);
    const channel = this.lineStateAction.channelStateInfo;
    this.bg_image = this.bg_image.replace("#brand#", channel.comCode);
    this.route.queryParams.take(1).subscribe(async (params) => {
      console.log("query params:", params);
      this.navigate = decodeURIComponent(params['navigate'])
      this.logger.info(`${this.log_session_text} query params: ${JSON.stringify(params)}`);
      this.logger.info(`${this.log_session_text} query params navigate : ${JSON.stringify(params['navigate'])}`);
      if (params['queryParams']) {
        this.queryParams = JSON.parse(decodeURIComponent(params['queryParams']));
      }
    })
  }

  async onSubmit() {
    const funcName = 'onSubmit';
    this.loaderService.opendLoader();
    const channel = this.lineStateAction.channelStateInfo;
    this.logger.info(`${this.log_session_text} ${funcName} channel:${JSON.stringify(channel)}`);
    const payload: VerifyIdentity = {
      identity_id: this.model().form.idcard.value,
      ref_code: channel.refCode
    }
    this.logger.info(`${this.log_session_text} ${funcName} apiVerifyIdentity start`);
    this.verifyIdentityService.apiVeifyIndentity(payload).subscribe(
      response => {
        this.loaderService.closeLoader();
        this.logger.info(`${this.log_session_text} ${funcName} apiVerifyIdentity response state_code:${response?.state_code}`);
        if (response.state_code == ResponseStateVerifyIdentity.MATCH) {          
          channel.verify_identity_token = response.data;
          // this.router.navigate(["./completed"],{relativeTo:this.route,queryParams:{ status: "success" }});          
          this.logger.info(`${this.log_session_text} ${funcName} apiVerifyIdentity response match`);
          this.router.navigate([this.navigate], { relativeTo: this.route, queryParams: this.queryParams });
        } else {
          this.logger.info(`${this.log_session_text} ${funcName} apiVerifyIdentity response not match`);
          this.verifyIdentityInvalid.set(true);
          channel.verify_identity_token = null;
        }
      },
      error => {
        this.loaderService.closeLoader();
        this.logger.error(`${this.log_session_text} ${funcName} apiVerifyIdentity error:${error?.message}`);
        console.log(error);
      }
    )
  }

  addClass(f: NgForm, field: string, type?: string, valueActive = '') {
    const iClass = [];
    if (f.form.get(field) && type !== 'msg') {
      if (f.form.get(field).invalid && (f.form.get(field).dirty || f.form.get(field).touched || f.submitted)) {
        iClass.push('uk-form-danger');
      } else if (f.form.get(field).valid && (f.form.get(field).dirty || f.form.get(field).touched || f.submitted)) {
        if (valueActive === '') {
          iClass.push('uk-form-success');
        } else if (f.form.get(field).value === valueActive) {
          iClass.push('uk-form-success');
        }
      }
    } else if (f.form.get(field) && type === 'msg') {
      if (f.form.get(field).invalid && (f.form.get(field).dirty || f.form.get(field).touched || f.submitted)) {
        iClass.push('uk-animation-fade');
      } else if (f.form.get(field).valid && (f.form.get(field).dirty || f.form.get(field).touched || f.submitted)) {
        iClass.push('uk-animation-reverse');
      }
    }

    return iClass;
  }

  validateIdCard = (value: string): Promise<boolean> => {
    this.verifyIdentityInvalid.set(false);
    if (value === '') { return Promise.resolve(false); }
    if (value != null && value.length < 13) { return Promise.resolve(false); }
    if (value != null && value.length === 13) {
      // STEP 1 - get only first 12 digits
      let idSum = 0;
      for (let i = 0; i < 12; i++) {
        // STEP 2 - multiply each digit with each index (reverse)
        // STEP 3 - sum multiply value together
        // tslint:disable-next-line: radix
        idSum += parseInt(value.charAt(i)) * (13 - i);
      }

      // STEP 4 - mod sum with 11
      const mod = idSum % 11;

      // STEP 5 - subtract 11 with mod, then mod 10 to get unit
      const check = (11 - mod) % 10;
      // STEP 6 - if check is match the digit 13th is correct
      // tslint:disable-next-line: radix
      if (check === parseInt(value.charAt(12))) {
        return Promise.resolve(true);
      }
      return Promise.resolve(false);
    }
    return Promise.resolve(true);
  }

}
